export default "/images/0b3f1ae5b086afe737da9699de9d796b.avif";